/* PawMom — Design Refresh behaviour. Vanilla JS, no dependencies.
   Progressive enhancement only: every feature here degrades to the
   original theme behaviour (form posts, page navigation) if JS fails. */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function formatMoney(cents, fmt) {
    var value = (cents / 100).toFixed(2);
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, value)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function imgSize(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  /* ---------- mobile drawer: lock body scroll via class (keeps pawmom.js behaviour) ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]')) document.body.classList.add('pm-drawer-open');
    if (e.target.closest('[data-nav-close]')) document.body.classList.remove('pm-drawer-open');
  });

  /* ---------- predictive search ---------- */
  function initPredictive(form) {
    var input = form.querySelector('input[type="search"]');
    var box = form.parentNode.querySelector('[data-predict]');
    if (!input || !box) return;
    var lastQ = '';
    function close() { box.hidden = true; box.innerHTML = ''; }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (q === lastQ) return;
      lastQ = q;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(url, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (data) {
        if (input.value.trim() !== q) return;
        var res = (data && data.resources && data.resources.results) || {};
        var products = res.products || [];
        var collections = res.collections || [];
        var html = '';
        if (collections.length) {
          html += '<div class="pm-predict__head">Categories</div>';
          collections.slice(0, 3).forEach(function (c) {
            html += '<a class="pm-predict__item" href="' + esc(c.url) + '"><b>' + esc(c.title) + '</b></a>';
          });
        }
        if (products.length) {
          html += '<div class="pm-predict__head">Products</div>';
          products.forEach(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(imgSize(p.featured_image.url, 96)) + '" alt="" loading="lazy" width="48" height="48">' : '<span style="width:48px;height:48px;border-radius:8px;background:var(--cream-3);display:block"></span>';
            var meta = [p.type, p.price ? formatMoney(Math.round(parseFloat(p.price) * 100), box.dataset.moneyFormat) : ''].filter(Boolean).join(' · ');
            html += '<a class="pm-predict__item" href="' + esc(p.url) + '">' + img + '<span><b>' + esc(p.title) + '</b><span>' + esc(meta) + '</span></span></a>';
          });
        }
        if (!html) html = '<div class="pm-predict__empty">No matches for “' + esc(q) + '”. Try “memorial”, “quilt set” or a pet’s name.</div>';
        html += '<a class="pm-predict__more" href="' + root + 'search?q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '” →</a>';
        box.innerHTML = html;
        box.hidden = false;
      }).catch(close);
    }, 180);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (box.innerHTML) box.hidden = false; });
    document.addEventListener('click', function (e) { if (!form.parentNode.contains(e.target)) close(); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }
  document.querySelectorAll('[data-predictive-form]').forEach(initPredictive);

  /* ---------- collection description clamp ---------- */
  document.querySelectorAll('[data-clamp]').forEach(function (el) {
    var btn = el.parentNode.querySelector('[data-clamp-toggle]');
    if (!btn) return;
    el.classList.add('is-clamped');
    if (el.scrollHeight <= el.clientHeight + 4) { btn.hidden = true; el.classList.remove('is-clamped'); return; }
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = el.classList.toggle('is-clamped');
      btn.textContent = open ? btn.dataset.more : btn.dataset.less;
    });
  });

  /* ---------- filter drawer ---------- */
  var filters = document.querySelector('[data-filters]');
  if (filters) {
    function openF() { filters.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeF() { filters.classList.remove('is-open'); document.body.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-filters-open]')) { e.preventDefault(); openF(); }
      if (e.target.closest('[data-filters-close]')) { e.preventDefault(); closeF(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeF(); });
  }

  /* ---------- sort select: submit on change, keep filter params ---------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.querySelector('[data-pm-cart]');
  var money = drawer ? (drawer.dataset.moneyFormat || '${{amount}}') : '${{amount}}';
  var threshold = drawer ? parseInt(drawer.dataset.shipThreshold || '0', 10) : 0;

  function renderShip(container, total) {
    if (!container) return;
    if (!threshold) { container.innerHTML = ''; return; }
    var left = threshold - total;
    var pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
    var done = left <= 0;
    container.className = 'pm-ship' + (done ? ' pm-ship--done' : '');
    container.innerHTML = '<p class="pm-ship__text">' + (done ? '<b>You’ve unlocked free shipping.</b>' : 'Add <b>' + formatMoney(left, money) + '</b> more for free shipping') + '</p><div class="pm-ship__bar" role="progressbar" aria-valuenow="' + pct + '" aria-valuemin="0" aria-valuemax="100"><div class="pm-ship__fill" style="width:' + pct + '%"></div></div>';
  }

  function renderCart(cart, addedKey) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-pm-cart-body]');
    var count = drawer.querySelector('[data-pm-cart-count]');
    var total = drawer.querySelector('[data-pm-cart-total]');
    var foot = drawer.querySelector('[data-pm-cart-foot]');
    if (count) count.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
    if (total) total.textContent = formatMoney(cart.total_price, money);
    var html = '';
    if (!cart.items.length) {
      html = '<div class="pm-cart__empty"><h3>Your cart is empty.</h3><p>Pick a print and we will match the rest of the room to it.</p><a class="btn btn--primary" href="' + root + 'collections/shop-all">Shop everything</a></div>';
      if (foot) foot.hidden = true;
    } else {
      if (foot) foot.hidden = false;
      if (addedKey) html += '<div class="pm-cart__added" data-pm-added><svg class="pm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>Added to your cart</div>';
      html += '<div class="pm-ship" data-pm-ship></div>';
      cart.items.forEach(function (it, i) {
        var props = '';
        Object.keys(it.properties || {}).forEach(function (k) {
          if (k.charAt(0) === '_' || it.properties[k] === '' || it.properties[k] == null) return;
          props += '<small>' + esc(k) + ': ' + esc(it.properties[k]) + '</small>';
        });
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '';
        var compare = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price, money) + '</s>' : '';
        html += '<div class="pm-cart__item" data-line="' + (i + 1) + '">' +
          '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgSize(it.image, 144)) + '" alt="" width="72" height="72" loading="lazy">' : '<span style="display:block;width:72px;height:72px;border-radius:10px;background:var(--cream-3)"></span>') + '</a>' +
          '<div><h3><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h3>' + variant + props +
          '<div style="display:flex;align-items:center"><div class="qty"><button type="button" data-pm-qty="-1" aria-label="Decrease">−</button><input type="number" value="' + it.quantity + '" min="0" aria-label="Quantity" data-pm-qty-input><button type="button" data-pm-qty="1" aria-label="Increase">+</button></div><a href="' + root + 'cart/change?line=' + (i + 1) + '&quantity=0" class="cart__remove" data-pm-remove>Remove</a></div></div>' +
          '<div class="pm-cart__price">' + formatMoney(it.final_line_price, money) + compare + '</div></div>';
      });
    }
    body.innerHTML = html;
    renderShip(body.querySelector('[data-pm-ship]'), cart.total_price);
    var hc = document.querySelector('.header__cart');
    if (hc) {
      var bubble = hc.querySelector('.header__count');
      if (cart.item_count > 0) {
        if (!bubble) { bubble = document.createElement('span'); bubble.className = 'header__count'; hc.appendChild(bubble); }
        bubble.textContent = cart.item_count;
      } else if (bubble) { bubble.remove(); }
    }
  }
  function openCart() { if (!drawer) return; drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; var c = drawer.querySelector('[data-pm-cart-close]'); if (c) c.focus(); }
  function closeCart() { if (!drawer) return; drawer.classList.remove('is-open'); document.body.style.overflow = ''; }
  function loadCart(addedKey) {
    return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart, addedKey); return cart; });
  }
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(function (cart) { renderCart(cart); });
  }

  if (drawer) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pm-cart-close]')) { e.preventDefault(); closeCart(); }
      var q = e.target.closest('[data-pm-qty]');
      if (q && drawer.contains(q)) {
        var row = q.closest('[data-line]');
        var input = row.querySelector('[data-pm-qty-input]');
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.dataset.pmQty, 10));
        changeLine(parseInt(row.dataset.line, 10), next);
      }
      var rm = e.target.closest('[data-pm-remove]');
      if (rm && drawer.contains(rm)) { e.preventDefault(); changeLine(parseInt(rm.closest('[data-line]').dataset.line, 10), 0); }
    });
    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-pm-qty-input]');
      if (!input) return;
      changeLine(parseInt(input.closest('[data-line]').dataset.line, 10), Math.max(0, parseInt(input.value, 10) || 0));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });

    /* AJAX add-to-cart on the product form. Stands down when the Teeinblue
       personaliser owns the form, so its own validation + add flow is untouched. */
    document.querySelectorAll('form.pdp__form[data-variant-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (form.querySelector('#tee-artwork-form')) return;           // Teeinblue active → native flow
        var btn = form.querySelector('[data-add-button]');
        if (btn && btn.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
        e.preventDefault();
        if (btn) btn.setAttribute('aria-busy', 'true');
        var fd = new FormData(form);
        fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function (item) { return loadCart(item.key); })
          .then(function () { if (btn) btn.removeAttribute('aria-busy'); openCart(); })
          .catch(function () { if (btn) btn.removeAttribute('aria-busy'); form.submit(); }); // fall back to the normal post
      });
    });
  }

  /* ---------- sticky mobile add-to-cart ---------- */
  var sticky = document.querySelector('[data-pm-sticky]');
  var buyBtn = document.querySelector('.pdp__form [data-add-button]');
  if (sticky && buyBtn) {
    document.body.classList.add('has-sticky-atc');
    var stickyBtn = sticky.querySelector('[data-pm-sticky-btn]');
    var stickyPrice = sticky.querySelector('[data-pm-sticky-price]');
    var ticking = false;
    function judge() {
      ticking = false;
      var r = buyBtn.getBoundingClientRect();
      sticky.classList.toggle('is-visible', r.bottom < 0);          // button scrolled past the top
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(judge); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    judge();
    if (stickyBtn) stickyBtn.addEventListener('click', function () { buyBtn.click(); });
    var priceSrc = document.querySelector('[data-variant-price]');
    if (priceSrc && stickyPrice) {
      var sync = function () { stickyPrice.textContent = priceSrc.textContent.trim(); };
      new MutationObserver(sync).observe(priceSrc, { childList: true, subtree: true, characterData: true });
      sync();
    }
    var syncBtn = function () {
      if (!stickyBtn) return;
      var disabled = buyBtn.getAttribute('aria-disabled') === 'true';
      stickyBtn.textContent = buyBtn.textContent.trim();
      if (disabled) stickyBtn.setAttribute('aria-disabled', 'true'); else stickyBtn.removeAttribute('aria-disabled');
    };
    new MutationObserver(syncBtn).observe(buyBtn, { childList: true, attributes: true, characterData: true, subtree: true });
    syncBtn();
  }

  /* ---------- price sync: the price sits outside the product form, so pawmom.js cannot reach it ---------- */
  document.querySelectorAll('form[data-variant-form]').forEach(function (form) {
    var data = form.querySelector('[data-variant-json]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('.pdp__price[data-variant-price]');
    if (!data || !idInput || !priceEl || form.contains(priceEl)) return;
    var variants; try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var fmt = form.dataset.moneyFormat || '${{amount}}';
    function sync() {
      var v = variants.filter(function (x) { return String(x.id) === String(idInput.value); })[0];
      if (!v) return;
      var html = '<span class="' + (v.compare_at_price > v.price ? 'is-sale' : '') + '">' + formatMoney(v.price, fmt) + '</span>';
      if (v.compare_at_price > v.price) html += '<s>' + formatMoney(v.compare_at_price, fmt) + '</s>';
      priceEl.innerHTML = html;
    }
    form.addEventListener('click', function (e) { if (e.target.closest('.opt__value')) setTimeout(sync, 0); });
  });

  /* ---------- selected option value beside label ---------- */
  document.querySelectorAll('[data-option-index]').forEach(function (group) {
    var out = group.querySelector('[data-opt-selected]');
    if (!out) return;
    var sync = function () { var a = group.querySelector('.opt__value.is-active'); out.textContent = a ? a.dataset.value : ''; };
    group.addEventListener('click', function () { setTimeout(sync, 0); });
    sync();
  });
})();
